





































































































































import { PaginatedList } from "@/api/models/common/paginatedList";
import { Processus } from "@/api/models/fichesIncident/processus";
import CreateProcessus from "./CreateProcessus.vue";
import UpdateProcessus from "./EditProcessus.vue";
import {
  BButton,
  BCard,
  BCol,
  BDropdown,
  BFormSelect,
  BDropdownItem,
  BFormInput,
  BPagination,
  BRow,
  BTable,
  BAlert,
} from "bootstrap-vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BAlert,
    BButton,
    BFormInput,
    BTable,
    BPagination,
    BDropdown,
    BDropdownItem,
    BFormSelect,
    CreateProcessus,
    UpdateProcessus,
  },
})
export default class ListProcessuss extends Vue {
  perPage = 10;
  currentPage = 1;
  perPageOptions = [2, 5, 10, 25, 50, 100];
  isAddNewProcessusSidebarActive = false;
  isUpdateProcessusSidebarActive = false;
  selectedProcessusId = "";

  tableColumns = [
    { key: "nom", sortable: true },
    { key: "pilote", sortable: true },
    { key: "nbMembres", label: "Nb membres", sortable: false },
    { key: "actions" },
  ];
  paginatedListProcessus = new PaginatedList<Processus>();

  async created() {
    await this.loadListProcessus({
      pageNumber: this.currentPage,
      pageSize: this.perPage,
    });
  }

  get paginationFrom() {
    return (
      this.perPage * (this.currentPage - 1) +
      (this.paginatedListProcessus.items.length ? 1 : 0)
    );
  }
  get paginationTo() {
    return (
      this.perPage * (this.currentPage - 1) +
      this.paginatedListProcessus.items.length
    );
  }

  @Watch("currentPage")
  @Watch("perPage")
  async paginationChanged() {
    await this.loadListProcessus({
      pageNumber: this.currentPage,
      pageSize: this.perPage,
    });
  }

  editProcessus(processusId: string) {
    this.selectedProcessusId = processusId;
    this.isUpdateProcessusSidebarActive = true;
  }

  async loadListProcessus(params: any) {
    if (!params || params?.reset) {
      this.paginatedListProcessus = new PaginatedList<Processus>();
    }
    await this.$http.myressif.processus
      .searchPaginatedList(params?.pageNumber ?? 1, params?.pageSize ?? 10)
      .then((response: PaginatedList<Processus>) => {
        this.paginatedListProcessus = response;
      });
  }

  askDelete(id: string) {
    this.$bvModal
      .msgBoxConfirm("Etes-vous sûr de vouloir supprimer ce processus ?", {
        title: "Confirmation de suppression",
        size: "sm",
        okVariant: "primary",
        okTitle: "Oui",
        cancelTitle: "Non",
        cancelVariant: "outline-secondary",
        hideHeaderClose: false,
        centered: true,
      })
      .then(async (value) => {
        if (value === true) {
          await this.confirmDelete(id);
        } else {
          return;
        }
      });
  }

  async confirmDelete(id: string) {
    await this.$http.myressif.processus
      .delete(id)
      .then(
        async (response: string) => {
          successAlert.fire({
            title: "Suppression d'un processus",
            text: "Suppression effectuée avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$emit("refresh-processus");
        this.loadListProcessus({
          pageNumber: this.currentPage,
          pageSize: this.perPage,
        });
      });
  }
}
